import { UseQueryResult, useQuery } from 'react-query';
import { SalesPortalPackageRetrieve } from 'types';
import { client } from 'utils/api-client';

export default function useAthleteSalesPortalPackage(
  packageId: string | undefined,
  profileId?: string,
): UseQueryResult<{ data: SalesPortalPackageRetrieve }> {
  return useQuery(
    ['athleteSalesPortalPackage', packageId, profileId],
    () => client.get(`packages/${packageId}/athlete-sales-portal-retrieve`),
    {
      enabled: !!packageId,
    },
  );
}
